export default {
  panel: {
    e_no_settings: "Settings настройки панели отображения данных отсутствуют!\nОбратитесь к администратору системы.",
    e_error_values: "Setting панель отображения данных имеет неизвестное значение!\nОбратитесь к администратору системы."
  }
}
